import { EMPTY_STRING } from '@e-socna/empty';
import type { Id } from '@e-socna/data-layer';

type DocumentChoiceValues = Readonly<{
  templateId?: Id | typeof EMPTY_STRING | null;
  title?: string | null;
  code?: string | null;
}>;

const valueOrAbsent = (value: string | null | undefined) =>
  value === EMPTY_STRING ? undefined : value;

// An emptied template field is sent as no template (an empty id is not one), an emptied title or
// code as absent (the back then takes its default, or asks for it); an untouched field stays
// absent.
export const documentChoiceForm2ApiMapper = <V extends object>(
  values: V,
): Omit<V, keyof DocumentChoiceValues> & {
  templateId?: Id | null;
  title?: string | null;
  code?: string | null;
} => {
  const { templateId, title, code, ...otherValues } = values as V &
    DocumentChoiceValues;

  return {
    ...otherValues,
    templateId: templateId === EMPTY_STRING ? null : templateId,
    ...(title === undefined ? {} : { title: valueOrAbsent(title) }),
    ...(code === undefined ? {} : { code: valueOrAbsent(code) }),
  };
};
